/**
 * 用户相关的所有ajax函数
 */

import request from "@/utils/request";
import $ from "jquery";
 var signBaseUrl="http://127.0.0.1:15322";
/* 登录 */
export const getSysUser = (data) => {
  return request({
    url: "/sysApi/getSysUserVo",
    method: "post",
    data,
  });
};
/* 绑定CA */
export const bindCA = (data) => {
  return request({
    url: "/sysApi/bindCert",
    method: "post",
    data,
  });
};
/* formData  请求方式 */
export const getSysUsers = (data) => {
  return request({
    url: "/sysApi/getSysUserVo",
    method: "post",
    headers: {
      "content-Type": "multipart/form-data",
    },
    data,
  });
};

/* formData  请求方式 */
export const saveUserOrg = (data) => {
  return request({
    url: "/sysApi/saveUserOrg",
    method: "post",
    headers: {
      "content-Type": "multipart/form-data",
    },
    data,
  });
};


export const bidCert =  (password,callback)=> {
  var type = "get";
  var dataType = "json";
  $.ajax({
    url:
    signBaseUrl+"/api/ukey/getUkeyCertificate?pin=" +
      password +
      "&type=1",
    type: type,
    dataType: dataType,
    async: false,
    success: function (res) {
      callback(1,res.data);
    },
    error: function (e) {

      callback(0,e);
    },
  });
};
export const getUkeyId =  (callback)=> {
  var type = "get";
  var dataType = "json";
  $.ajax({
    url:
    signBaseUrl+"/api/ukey/getUkeyId",
    type: type,
    dataType: dataType,
    async: false,
    success: function (res) {
      callback(1,res);
    },
    error: function (e) {
      callback(0,e);
    },
  });
};
export const getCert =  (data,callback)=> {
  var type = "post";
  var dataType = "json";
  $.ajax({
    url:signBaseUrl+"/api/ukey/exportCert",
    type: type,
    dataType: dataType,
    data:data,
    async: false,
    success: function (res) {
      callback(1,res);
    },
    error: function (e) {
      callback(0,e);
    },
  });
};
/* formData  请求方式 */
export const bidCert2 = function bidCert2() {
  var type = "get";
  var dataType = "json";

  $.ajax({
    url: "http://127.0.0.1:8084/api/ping",

    type: type,
    dataType: dataType,

    async: false,
    success: function (res) {
      alert(res.data);
    },
    error: function () {
      alert("请检查客户端是否安装并且开启？");
    },
  });
};
